<template>
  <div class="idcard" :class="$store.state.user.isNested && 'pb300'">
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ l.id_nav_title }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="form_body">
      <!-- 进度条 -->
      <div class="stepImg_box">
        <img class="stepImg" src="@/assets/userInfo/tab1.png" alt=""/>
      </div>
      <!-- 表单部分 -->
      <div class="form_class">
        <Form
            name="form"
            ref="form"
            validate-first
            @submit="handleFormCommit"
            @failed="onFailed"
            :scroll-to-error="true"
            :disabled="$route.query.from == 'my'"
        >
          <div class="certification">
            <div class="certificationTitle">{{ l.id_id_certification }}</div>
            <LableBox class="idCardType" :label="l.id_idcard_type">
              <Field
                  name="idCardType"
                  :readonly="echoShow"
                  v-model="formData.idType"
                  :rules="[{ required: true, message: l.id_s_idcard_type }]"
              >
                <template #input>
                  <!-- {{formData.idType}} -->
                  <!-- @change="onChange" -->
                  <div class="idTypeText">CCCD</div>
                </template>
              </Field>
            </LableBox>

            <div v-if="!echoShow">
              <!-- 身份证正面 -->
              <div class="img_first">
                <Field
                    readonly
                    class="fieldImg"
                    name="imgIdCardPositive"
                    style="background: none"
                    v-model="formData.imgIdCardPositive"
                    :rules="[{ required: true }]"
                >
                  <template #input>
                    <div class="upload-out-box">
                      <div class="uploadBox">
                        <div
                            class="uploadBtn"
                            @click="clickUpload('imgIdCardPositive')"
                        >
                          <img
                              v-show="
                              formData.imgIdCardPositive === '' ||
                                formData.imgIdCardPositive === null
                            "
                              class="photoImg"
                              :src="require('@/assets/userInfo/face2@2x.png')"
                              alt=""
                          />
                          <div
                              v-show="
                              formData.imgIdCardPositive === '' ||
                                formData.imgIdCardPositive === null
                            "
                              class="upload_title"
                          >
                            {{ l.id_update_idcard_positive }}
                          </div>
                          <!-- <van-loading
                        v-show="imgIdCardPositiveLoadingShow"
                        type="spinner"
                        color="#1989fa"
                        style="
                          text-align: center;
                          height: 100px;
                          line-height: 100px;
                        "
                      /> -->
                          <div
                              :style="{
                              backgroundImage: `url(${require('@/assets/userInfo/idcardPositive.png')})`,
                            }"
                              v-show="imgIdCardPositiveLoadingShow"
                              class="loadingBox"
                          ></div>
                          <img
                              class="hxShowImg"
                              v-show="
                              !imgIdCardPositiveLoadingShow &&
                                (formData.imgIdCardPositive === '' ||
                                  formData.imgIdCardPositive === null)
                            "
                              :src="
                              require('@/assets/userInfo/idcardPositive.png')
                            "
                          />
                        </div>

                        <img
                            @click="clickUpload('imgIdCardPositive')"
                            class="hxShowImg updloadShowimg"
                            v-show="
                            !imgIdCardPositiveLoadingShow &&
                              formData.imgIdCardPositive
                          "
                            :src="formData.imgIdCardPositive"
                        />
                      </div>
                    </div>
                  </template>
                </Field>
                <!-- 身份证反面 -->

                <Field
                    readonly
                    class="fieldImg"
                    name="imgIdCardBack"
                    style="background: none"
                    v-model="formData.imgIdCardBack"
                    :rules="[{ required: true }]"
                >
                  <template #input>
                    <div class="upload-out-box">
                      <div
                          class="uploadBox"
                          @click="clickUpload('imgIdCardBack')"
                      >
                        <div class="uploadBtn">
                          <!-- <van-loading
                        v-show="imgIdCardBackLoadingShow"
                        type="spinner"
                        color="#1989fa"
                        style="
                          text-align: center;
                          height: 100px;
                          line-height: 100px;
                        "
                      /> -->
                          <div
                              :style="{
                              backgroundImage: `url(${require('@/assets/userInfo/idcardback.png')})`,
                            }"
                              v-show="imgIdCardBackLoadingShow"
                              class="loadingBox"
                          ></div>
                          <img
                              v-show="
                              formData.imgIdCardBack === '' ||
                                formData.imgIdCardBack === null
                            "
                              class="photoImg"
                              :src="require('@/assets/userInfo/face2@2x.png')"
                              alt=""
                          />
                          <div
                              v-show="
                              formData.imgIdCardBack === '' ||
                                formData.imgIdCardBack === null
                            "
                              class="upload_title"
                          >
                            {{ l.id_update_idcard_back }}
                          </div>
                          <img
                              class="hxShowImg"
                              v-show="
                              !imgIdCardBackLoadingShow &&
                                (formData.imgIdCardBack === '' ||
                                  formData.imgIdCardBack === null)
                            "
                              :src="require('@/assets/userInfo/idcardback.png')"
                          />
                        </div>

                        <img
                            @click="clickUpload('imgIdCardBack')"
                            class="hxShowImg updloadShowimg"
                            v-show="
                            !imgIdCardBackLoadingShow && formData.imgIdCardBack
                          "
                            :src="formData.imgIdCardBack"
                        />
                      </div>
                    </div>
                  </template>
                </Field>
              </div>
              <div class="cardBox">
                <div class="cardTitle">{{ l.id_card_precautions }}</div>
                <p class="cardMsg">
                  {{ l.id_card_hold_msg1 }}
                  <br/>
                  {{ l.id_card_msg1 }}
                  <br/>
                  {{ l.id_card_msg2 }}
                </p>
              </div>
              <!-- 银行存折封面 -->
              <div class="img_first">
                <Field
                    class="fieldImg handheld"
                    name="imgIdCardHold"
                    style="background: none"
                >
                  <template #input>
                    <div class="upload-out-box">
                      <div class="uploadBox">
                        <div class="uploadBtn"
                             @click="toChooseFiled('imgIdCardHold')">
                          <!-- <van-loading
                        v-show="imgIdCardHoldLoadingShow"
                        type="spinner"
                        color="#1989fa"
                        style="
                          text-align: center;
                          height: 100px;
                          line-height: 100px;
                        "
                      /> -->
                          <div
                              :style="{
                              backgroundImage: `url(${require('@/assets/userInfo/IdcardHold.png')})`,
                            }"
                              v-show="imgIdCardHoldLoadingShow"
                              class="loadingBox"
                          ></div>
                          <img
                              @click="toChooseFiled('imgIdCardHold')"
                              v-show="
                              formData.imgIdCardHold === '' ||
                                formData.imgIdCardHold === null
                            "
                              class="photoImg"
                              :src="require('@/assets/userInfo/photo.png')"
                              alt=""
                          />
                          <div
                              v-show="
                              formData.imgIdCardHold === '' ||
                                formData.imgIdCardHold === null
                            "
                              @click="toChooseFiled('imgIdCardHold')"
                              class="upload_title"
                          >
                            {{ l.id_update_idcard_hold }}
                          </div>
                          <!-- <img
                          class="hxShowImg img_imgIdCardHold"
                          @click="toChooseFiled('imgIdCardHold')"
                          v-show="!imgIdCardHoldLoadingShow"
                          :class="
                            formData.imgIdCardHold && 'uploadImg uploadImg2'
                          "
                          :src="
                            formData.imgIdCardHold === '' ||
                            formData.imgIdCardHold === null
                              ? require('@/assets/userInfo/IdcardHold.png')
                              : formData.imgIdCardHold
                          "
                        /> -->
                          <img
                              class="hxShowImg"
                              v-show="
                              !imgIdCardHoldLoadingShow &&
                                (formData.imgIdCardHold === '' ||
                                  formData.imgIdCardHold === null)
                            "
                              :src="require('@/assets/userInfo/IdcardHold.png')"
                          />
                        </div>

                        <img
                            @click="clickUpload('imgIdCardHold')"
                            class="hxShowImg updloadShowimg"
                            v-show="
                            !imgIdCardHoldLoadingShow && formData.imgIdCardHold
                          "
                            :src="formData.imgIdCardHold"
                        />
                      </div>
                    </div>
                  </template>
                </Field>

                <Field
                    class="fieldImg handheld"
                    name="imgBankSavebook"
                    style="background: none"
                >
                  <template #input>
                    <div class="upload-out-box">
                      <div class="uploadBox">
                        <div class="uploadBtn"
                             @click="clickUpload('imgBankSavebook')">
                          <div
                              :style="{
                              backgroundImage: `url(${require('@/assets/userInfo/IdcardHold.png')})`,
                            }"
                              v-show="imgBankSavebookLoadingShow"
                              class="loadingBox"
                          ></div>
                          <img
                              @click="clickUpload('imgBankSavebook')"
                              v-show="
                              formData.imgBankSavebook === '' ||
                                formData.imgBankSavebook === null
                            "
                              class="photoImg"
                              :src="require('@/assets/userInfo/photo.png')"
                              alt=""
                          />
                          <div
                              v-show="
                              formData.imgBankSavebook === '' ||
                                formData.imgBankSavebook === null
                            "
                              @click="clickUpload('imgBankSavebook')"
                              class="upload_title"
                          >
                            {{ l.id_bank_passbook_cover }}
                          </div>
                          <img
                              class="hxShowImg"
                              v-show="
                              !imgBankSavebookLoadingShow &&
                                (formData.imgBankSavebook === '' ||
                                  formData.imgBankSavebook === null)
                            "
                              :src="require('@/assets/userInfo/IdcardHold.png')"
                          />
                        </div>

                        <img
                            @click="clickUpload('imgBankSavebook')"
                            class="hxShowImg updloadShowimg"
                            v-show="
                            !imgBankSavebookLoadingShow && formData.imgBankSavebook
                          "
                            :src="formData.imgBankSavebook"
                        />
                      </div>
                    </div>
                  </template>
                </Field>
              </div>
              <div class="cardBox">
                <div class="cardTitle">{{ l.id_card_precautions }}</div>
                <p class="cardMsg">
                  {{ l.id_card_hold_msg2 }}
                  <br/>
                  {{ l.id_card_hold_msg3 }}
                </p>
              </div>
            </div>
            <div v-if="echoShow">
              <div class="img_box">
                <div class="img_title">{{ l.id_idcard_positive }}</div>
                <img :src="formData.imgIdCardPositive"/>
              </div>
              <div class="img_box">
                <div class="img_title">{{ l.id_idcard_back }}</div>
                <img :src="formData.imgIdCardBack"/>
              </div>
              <div class="img_box handheld2">
                <div class="img_title">{{ l.id_idcard_hold }}</div>
                <img :src="formData.imgIdCardHold"/>
              </div>
              <div class="img_box handheld2">
                <div class="img_title">{{ l.id_passbook_cover }}</div>
                <img :src="formData.imgBankSavebook"/>
              </div>
            </div>
          </div>
          <div class="certification">
            <div class="certificationTitle">{{ l.id_id_information }}</div>
            <LableBox class="formInfo" :label="l.id_real_name">
              <Field
                  :readonly="echoShow"
                  v-model="formData.real_name"
                  name="real_name"
                  :placeholder="l.id_p_real_name"
                  @focus="realFocus('real_name')"
                  maxlength="50"
                  :rules="[{ required: true }]"
              />
            </LableBox>
            <LableBox class="formInfo" :label="l.id_id_card">
              <Field
                  :readonly="echoShow"
                  v-model="formData.no_ktp"
                  name="no_ktp"
                  maxlength="10"
                  :rules="[
                  {
                    required: true,
                    pattern: /^[A-Z]{1}\d{9}$/,
                    message: l.id_id_card_format,
                  },
                  {
                    message: l.id_p_id_card,
                  },
                ]"
                  :placeholder="l.id_p_id_card"
              />
              <!-- :rules="[{ required: true }]" -->
              <!-- :placeholder="l.id_p_id_card" -->
            </LableBox>

            <LableBox class="formInfo" :label="l.id_sex">
              <Field
                  readonly
                  clickable
                  name="gender"
                  :value="formData.gender"
                  :placeholder="l.id_s_sex"
                  @click="realFocus('gender')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>
            <!-- educationPopup = true -->
            <Popup round v-model="genderPopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="genderOptions"
                  :default-index="genderDefaultIndex"
                  @confirm="genderChange"
                  @cancel="genderPopup = false"
              />
            </Popup>

<!--            <LableBox class="formInfo gender" :label="l.id_sex">-->
<!--              <Field name="gender" :readonly="echoShow">-->
<!--                <template #input>-->
<!--                  <div-->
<!--                      class="genderBox"-->
<!--                      :class="echoShow && 'genderBox_echoShow'"-->
<!--                  >-->
<!--                    <div-->
<!--                        @click="formData.gender = '1'"-->
<!--                        class="genderItem"-->
<!--                        :class="formData.gender == '1' && 'genderItem_select'"-->
<!--                    >-->
<!--                      {{ l.id_sex_gg }}-->
<!--                    </div>-->
<!--                    <div-->
<!--                        @click="formData.gender = '0'"-->
<!--                        class="genderItem"-->
<!--                        :class="formData.gender == '0' && 'genderItem_select'"-->
<!--                    >-->
<!--                      {{ l.id_sex_mm }}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; <RadioGroup-->
<!--                  checked-color="#45A1FF"-->
<!--                  class="commit_checkbox"-->
<!--                  :disabled="echoShow"-->
<!--                  v-model="formData.gender"-->
<!--                  direction="horizontal"-->
<!--                >-->
<!--                  <Radio :name="'1'"-->
<!--                    ><template #icon="props">-->
<!--                      <img-->
<!--                        class="commit_checkbox_img"-->
<!--                        :src="-->
<!--                          props.checked-->
<!--                            ? require('@/assets/home/hook2@2x.png')-->
<!--                            : require('@/assets/home/hook@2x.png')-->
<!--                        "-->
<!--                      /> </template-->
<!--                    >{{ l.id_sex_gg }}</Radio-->
<!--                  >-->
<!--                  <Radio :name="'2'"-->
<!--                    ><template #icon="props">-->
<!--                      <img-->
<!--                        class="commit_checkbox_img"-->
<!--                        :src="-->
<!--                          props.checked-->
<!--                            ? require('@/assets/home/hook2@2x.png')-->
<!--                            : require('@/assets/home/hook@2x.png')-->
<!--                        "-->
<!--                      /> </template-->
<!--                    >{{ l.id_sex_mm }}</Radio-->
<!--                  >-->
<!--                </RadioGroup> &ndash;&gt;-->
<!--                </template>-->
<!--              </Field>-->
<!--            </LableBox>-->

            <!-- 出生日期 -->
            <LableBox class="formInfo" :label="l.id_birthday">
              <Field
                  readonly
                  name="birthday"
                  :value="formData.birthday"
                  :rules="[{ required: true, message: '' }]"
                  :placeholder="l.id_s_birthday"
                  @click="realFocus('birthday')"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>
          </div>
          <!-- 出生日期弹框 -->
          <!-- 时间选择 -->
          <Popup v-model="showTimePopup" round position="bottom">
            <DatetimePicker
                :confirm-button-text="l.login_ok"
                :cancel-button-text="l.login_btn_cancel"
                v-model="defaultDate"
                type="date"
                :title="l.id_s_birthday"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="handleBirthdayChange"
                @cancel="showTimePopup = false"
            />
          </Popup>

          <!-- 下一步 -->
          <div>
            <Button
                class="nextStep"
                v-if="$route.query.from != 'my'"
                block
                type="info"
                native-type="submit"
            >{{ l.id_next_commit }}
            </Button
            >
          </div>
        </Form>
      </div>
    </div>
    <Popup class="commit_popup_con" position="bottom" v-model="commitPopup">
      <div class="commit_popup_con_box">
      <div @click="commitPopup = false" class="dialog_go_page_cancel"></div>
      <div class="dialog_go_page_title"><img src="@/assets/home/tips.png" alt=""> {{ l.my_setting_logout_title }}</div>
      <div class="pup_msg">{{ l.id_p_acknowledgment_msg }}</div>
      <Form @submit="onSubmit" size="small">
        <LableBox class="formInfo" :label="l.id_real_name">
          <Field
              v-model="realNamePoppup"
              maxlength="50"
              name="real_name"
              @focus="realFocus('model_realName')"
          >
            <template #right-icon>
              <img
                  class="commit_popup_img"
                  src="@/assets/xiugai-8@2x.png"
                  alt=""
              />
            </template>
          </Field>
        </LableBox>
        <LableBox class="formInfo" :label="l.id_acknowledgment_idcard">
          <Field
              v-model="idcardPoppup"
              maxlength="10"
              name="no_ktp"
              :rules="[
              {
                required: true,
                pattern: /^[A-Z]{1}\d{9}$/,
                message: l.id_id_card_format,
              },
              {
                message: l.id_p_id_card,
              },
            ]"
              @focus="realFocus('model_idCard')"
          >
            <template #right-icon>
              <img
                  class="commit_popup_img"
                  src="@/assets/xiugai-8@2x.png"
                  alt=""
              />
            </template>
          </Field>
        </LableBox>
        <div class="btn_con">
          <Button
              class="btn"
              :disabled="this.popCommitText !== this.l.id_confirm_btn"
              native-type="submit"
              type="info"
          >{{ popCommitText }}
          </Button
          >
        </div>
      </Form>
      </div>
    </Popup>
    <imageCamera
        style="display: none"
        echoField="imgIdCardHold"
        :showInner="true"
        @beforeRead="beforeRead"
        @afterRead="afterRead"
        ref="imageCamera"
    >
      <template>
        <img
            :src="
            formData.imgIdCardHold === '' || formData.imgIdCardHold === null
              ? require('@/assets/userInfo/IdcardHold.png')
              : formData.imgIdCardHold
          "
        />
      </template>
    </imageCamera>
    <imageCamera
        style="display: none"
        echoField="imgBankSavebook"
        :showInner="true"
        @beforeRead="beforeRead"
        @afterRead="afterRead"
        ref="imageCamera2"
    >
      <template>
        <img
            :src="
            formData.imgBankSavebook === '' || formData.imgBankSavebook === null
              ? require('@/assets/userInfo/IdcardHold.png')
              : formData.imgBankSavebook
          "
        />
      </template>
    </imageCamera>
    <idcardImageSelect
        :isClickClose="true"
        :showActions.sync="showActions"
        :echoField="showActionField"
        @beforeRead="beforeRead"
        @afterRead="afterRead"
    />
    <div class="face_post" v-if="showFacePost">
      <!-- <template v-if="!base64Img"> -->
      <video
          id="video"
          width="288"
          height="220"
          playsinline
          webkit-playsinline="true"
          preload
          autoplay
          loop
          muted
      ></video>
      <!-- <canvas id="canvas" width="288" height="220"></canvas> -->
      <canvas id="screenshotCanvasSteal" width="288" height="220"></canvas>
      <!-- </template> -->
    </div>
  </div>
</template>

<script>
import {
  Icon,
  // Progress,
  Form,
  Field,
  Button,
  // RadioGroup,
  // Radio,
  Popup,
  DatetimePicker,
  Toast,
  Loading,
  ActionSheet,
  Picker,
} from "vant";
import {
  userBaseInfoPre,
  queryUserBase,
  queryuserMedia,
  userDict,
} from "../../services/information";
import {dateFormat} from "../../utils";
import {lrzUploadImage} from "../../services/upload";
import l from "../../locales";
import LableBox from "../../components/lable-box";
import idcardImageSelect from "../../components/idcard-image-select";
import imageCamera from "../../components/image-camera";
import {genderOptions} from "@/utils/maps";

const date = new Date()
date.setFullYear(date.getFullYear() - 18)

export default {
  components: {
    Icon,
    // Progress,
    Form,
    Field,
    Button,
    // RadioGroup,
    // Radio,
    Popup,
    DatetimePicker,
    LableBox,
    idcardImageSelect,
    imageCamera,
    [Loading.name]: Loading,
    [ActionSheet.name]: ActionSheet,
    Picker,
  },
  data() {
    return {
      showFacePost: true,
      imgIdCardPositiveLoadingShow: false, // 身份证正面loading
      imgIdCardBackLoadingShow: false, // 身份证反面loading
      imgIdCardHoldLoadingShow: false, // 手持loading
      imgBankSavebookLoadingShow: false,
      showActions: false, // 展示选择照片拍照弹窗
      showActionField: "", // 回显字段
      l: {...l.idCard, ...l.login,...l.my},
      /**
       *
       * 表单数据
       *    name:姓名;
       *    no_ktp:身份证;
       *    gender: 性别;
       *    birthday:生日;
       *    imgIdCardPositive:身份证正面
       */
      formData: {
        real_name: "",
        idType: "2",
        no_ktp: "",
        gender: "",
        birthday: "",
        imgIdCardPositive: "", //身份证正面链接
        imgIdCardBack: "", //身份证反面链接
        imgIdCardHold: "", //手持身份证
        imgBankSavebook: "",
      },
      echoShow: false,

      genderPopup: false,
      genderDefaultIndex: 0,
      genderOptions: genderOptions,

      // 生日弹窗相关
      defaultDate: new Date(), // 时间选择change data
      showTimePopup: false, // 出生日期弹框控制变量
      // 时间选择器配置
      minDate: new Date(1890, 0, 1),
      maxDate: new Date(date),
      // 确认信息弹框变量
      commitPopup: false,
      realNamePoppup: "",
      idcardPoppup: "",
      timerOut: 3, // 弹窗确认按钮显示几秒
      popCommitText: "", // 按钮展示文案

      videoSteal: null,
      screenshotCanvasSteal: null,
      uploadLockSteal: true, // 上传锁
      base64ImgSteal: null,
      trackerTaskSteal: null,
    };
  },
  watch: {
    "formData.no_ktp"(val) {
      if(/[a-z]/.test(this.formData.no_ktp)){
        this.formData.no_ktp = val?.toUpperCase();
      }
    },
    "idcardPoppup"(val) {
      if(/[a-z]/.test(this.idcardPoppup)){
        this.idcardPoppup = val?.toUpperCase();
      }
    },
  },
  methods: {
    identificationDetection(file_type) {
      console.log("identificationDetection", file_type)
      window.getWebLivenessDetection = this.getWebLivenessDetection;
      this.$tools.androidMethod(
          "WebChromeClient",
          {
            imgUrl: "",
            file_type
          },
          "getWebLivenessDetection"
      );
    },
    getWebLivenessDetection(data) {
      console.log("getWebLivenessDetection", data)

      if (data.data.file_type == 1) {
        this.formData.imgIdCardPositive = data.data.imgUrl;
      } else if (data.data.file_type == 2) {
        this.formData.imgIdCardBack = data.data.imgUrl;
      } else if (data.data.file_type == 3) {
        this.formData.imgIdCardHold = data.data.imgUrl;
      } else if (data.data.file_type == 177) {
        this.formData.imgBankSavebook = data.data.imgUrl;
      }
    },
    toChooseFiled(field) {
      if (field == "imgIdCardHold") {
        if (process.env.VUE_APP_GENRE === "nested") {
          this.identificationDetection("3")
          return
        }
        this.realFocus(field);
        this.$refs.imageCamera.toChooseFile();
      }
      if (field == "imgBankSavebook") {
        if (process.env.VUE_APP_GENRE === "nested") {
          this.identificationDetection("177")
          return
        }
        this.realFocus(field);
        this.$refs.imageCamera2.toChooseFile();
      }
      console.log("toChooseFiled", field);
    },
    realFocus(str) {
      if (this.$route.query.from == "my") {
        return;
      }
      if (str == "birthday") {
        this.showTimePopup = !this.echoShow;
      }else if(str == "gender"){
        this.genderPopup = !this.echoShow;
      }
    },
    // 弹窗倒计时
    countdown() {
      let timer = setInterval(() => {
        if (this.timerOut > 1) {
          this.timerOut--;
          this.popCommitText = `${this.timerOut}S`;
        } else {
          clearInterval(timer);
          this.popCommitText = this.l.id_confirm_btn;
          this.timerOut = 3;
        }
      }, 1000);
    },
    // 身份证类型切换
    onChange() {
      if (!this.echoShow) {
        this.formData.imgIdCardPositive = "";
        this.formData.imgIdCardBack = "";
        this.formData.imgIdCardHold = "";
        this.formData.imgBankSavebook = "";
        this.formData.no_ktp = "";
        this.formData.birthday = "";
        this.formData.real_name = "";
        this.formData.gender = "";
      }
    },
    // 身份证正面反面上传弹窗
    clickUpload(showActionField) {
      if (showActionField == "imgIdCardPositive") {
        // 判断类型有没有选
        if (!["1", "2"].includes(this.formData.idType)) {
          // 请先选择身份证类型
          return Toast(this.l.id_before_select_id_type);
        }
        if (this.imgIdCardPositiveLoadingShow) {
          return;
        }
        if (process.env.VUE_APP_GENRE === "nested") {
          this.identificationDetection("1")
          return
        }
      } else if (showActionField == "imgIdCardBack") {
        // 判断正面有没有选择
        if (!this.formData.imgIdCardPositive) {
          // 请先上传身份证正面
          return Toast(this.l.id_before_upload_id_positive);
        }
        if (this.imgIdCardBackLoadingShow) {
          return;
        }
        if (process.env.VUE_APP_GENRE === "nested") {
          this.identificationDetection("2")
          return
        }
      } else if (showActionField == "imgBankSavebook") {
        if (this.imgBankSavebookLoadingShow) {
          return;
        }
        if (process.env.VUE_APP_GENRE === "nested") {
          this.identificationDetection("177")
          return
        }
      }
      this.showActionField = showActionField;
      this.showActions = true;
    },
    // 出生日期弹框确定按钮
    handleBirthdayChange(date) {
      const birstr = dateFormat("YYYY-mm-dd", date);
      this.formData.birthday = birstr;
      this.showTimePopup = false;
    },
    // header 返回触发
    handlenNavBarBack() {
      this.$router.back(1);
    },
    // 下一步点击弹出
    handleFormCommit(data) {
      if (this.echoShow) {
        // 回显跳转
        this.$router.push("/basicInformation");
        return;
      }
      if ([null, undefined, ""].includes(this.formData.imgIdCardHold)) {
        Toast(this.l.id_update_idcard_hold);
        return;
      }
      if ([null, undefined, ""].includes(this.formData.imgBankSavebook)) {
        Toast(this.l.id_bank_passbook_cover);
        return;
      }
      if (!this.formData.gender) {
        Toast(this.l.id_s_sex);
        return;
      }
      // 不回显直接弹窗
      // this.popCommitText = `${this.timerOut}S`;
      this.popCommitText = this.l.id_confirm_btn;
      this.commitPopup = true;
      this.realFocus("model_page", true);
      this.realNamePoppup = data.real_name ?? "123";
      this.idcardPoppup = data.no_ktp ?? "123";
      // this.countdown();
    },
    // 提交表单且数据验证不成功后回调事件
    onFailed(errorInfo) {
      console.log("errorInfo", errorInfo);
      let msg = errorInfo?.errors?.[0]?.message;
      if (errorInfo?.errors?.[0]?.name == "real_name") {
        msg = this.l.id_p_real_name;
      } else if (errorInfo?.errors?.[0]?.name == "imgIdCardPositive") {
        msg = this.l.id_update_idcard_positive;
      } else if (errorInfo?.errors?.[0]?.name == "imgIdCardBack") {
        msg = this.l.id_update_idcard_back;
      } else if (errorInfo?.errors?.[0]?.name == "imgIdCardHold") {
        msg = this.l.id_update_idcard_hold;
      } else if (errorInfo?.errors?.[0]?.name == "imgBankSavebook") {
        msg = this.l.id_bank_passbook_cover;
      } else if (errorInfo?.errors?.[0]?.name == "birthday") {
        msg = this.l.id_s_birthday;
      } else if (errorInfo?.errors?.[0]?.name == "no_ktp") {
        msg = this.l.id_p_id_card;
      }
      Toast(msg);
    },
    // 上传图片前的拦截 展不展示loading
    beforeRead(field) {
      if (field == "imgIdCardPositive") {
        // 正面
        this.imgIdCardPositiveLoadingShow = true;
      } else if (field == "imgIdCardBack") {
        // ocr认证
        this.imgIdCardBackLoadingShow = true;
      } else if (field == "imgIdCardHold") {
        // 手持
        this.imgIdCardHoldLoadingShow = true;
      } else if (field == "imgBankSavebook") {
        // 手持
        this.imgBankSavebookLoadingShow = true;
      }
    },
    // 上传图片后的回调
    afterRead(results, field, url) {
      console.log("afterRead", results, field, url);
      if (!results) {
        // 上传失败
        console.log("上传失败2");
        Toast.fail(this.l.id_upload_fail);
      }
      if (field == "imgIdCardPositive") {
        // results && url.url && (this.formData[field] = url.url);
        if (url.path) {
          this.formData[field] = "";
          // console.log(
          //   "url.pathurl.pathurl.pathurl.pathurl.pathurl.pathurl.pathurl.pathurl.pathurl.path1",
          //   url.path
          // );
          results && (this.formData[field] = url.path);
          // 正面
          // this.formData.imgIdCardBack = "";
          // this.formData.imgIdCardHold = "";
        } else {
          // console.log(
          //   "url.pathurl.pathurl.pathurl.pathurl.pathurl.pathurl.pathurl.pathurl.path2",
          //   url.path
          // );
          this.$saveAppsFlyer("ocr认证");
          this.formData.no_ktp = url.idNumber;
          this.formData.birthday = url.birthday;
          this.formData.real_name = url.name;
        }
        this.imgIdCardPositiveLoadingShow = false;
      } else if (field == "imgIdCardBack") {
        this.formData[field] = "";
        results && (this.formData[field] = url.path);
        // ocr认证
        this.imgIdCardBackLoadingShow = false;
        // this.formData.imgIdCardHold = "";
      } else if (field == "imgIdCardHold") {
        console.log("手持身份证回调.......................", field, url);
        this.formData[field] = "";
        results && (this.formData[field] = url.path);
        // 手持
        this.imgIdCardHoldLoadingShow = false;
      } else if (field == "imgBankSavebook") {
        this.formData[field] = "";
        results && (this.formData[field] = url.path);
        // 手持
        this.imgBankSavebookLoadingShow = false;
      }
    },
    // 性别选择
    genderChange(value, index) {
      console.log(value, index);
      this.formData.gender = value.name;
      this.genderPopup = false;
    },
    // 初始化设置
    async initTrackingSteal() {
      let _this = this;

      _this.$nextTick(() => {
        _this.videoSteal = document.getElementById("video");
        _this.screenshotCanvasSteal = document.getElementById(
            "screenshotCanvasSteal"
        );

        // let canvas = document.getElementById("canvas");
        // let context = canvas.getContext("2d");

        // 固定写法
        let tracker = new window.tracking.ObjectTracker("face");
        tracker.setInitialScale(4);
        tracker.setStepSize(2);
        tracker.setEdgesDensity(0.1);
        _this.trackerTaskSteal = window.tracking.track("#video", tracker, {
          camera: true,
        });

        tracker.on("track", function (event) {
          // 检测出人脸 绘画人脸位置
          // context.clearRect(0, 0, canvas.width, canvas.height);
          // event.data.forEach(function (rect) {
          event.data.forEach(function () {
            // context.strokeStyle = "#0764B7";
            // context.strokeRect(rect.x, rect.y, rect.width, rect.height);
            console.log("已识别到人脸");

            // 上传图片
            _this.uploadLockSteal && _this.screenshotAndUploadSteal();
            tracker = null;
          });
        });
        console.log("initTracking");
      });
    },
    // 上传图片
    screenshotAndUploadSteal() {
      let that = this;
      // 上锁避免重复发送请求
      this.uploadLockSteal = false;

      // 绘制当前帧图片转换为base64格式
      let canvas = this.screenshotCanvasSteal;
      let video = this.videoSteal;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(video, 0, 0, 2048, 2048);
      let base64Img = canvas.toDataURL("image/jpeg");

      // 使用 base64Img 请求接口即可
      // console.log('base64Img:', base64Img);
      this.base64ImgSteal = base64Img;
      //调用
      var file = this.base64toFile(base64Img);

      lrzUploadImage(file, "facePhoto1", () => {
        that.trackerTaskSteal && that.trackerTaskSteal.stop();
      });
      console.log("file", file);
      // 请求接口成功以后打开锁
    },
    base64toFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
    // 弹窗提交
    onSubmit(e) {
      if (this.popCommitText !== this.l.id_confirm_btn) {
        return;
      }
      if (this.formData.imgIdCardPositive === "") {
        Toast(this.l.id_update_idcard_positive);
        return;
      }
      if (this.formData.imgIdCardBack === "") {
        Toast(this.l.id_update_idcard_back);
        return;
      }
      if (this.formData.imgIdCardHold === "") {
        Toast(this.l.id_update_idcard_hold);
        return;
      }
      if (this.formData.imgBankSavebook === "") {
        Toast(this.l.id_bank_passbook_cover);
        return;
      }
      console.log("this.formData", this.formData);

      this.formData.gender = this.genderOptions.filter(
          (item) => item.name === this.formData.gender
      )[0].id;
      console.log("e", e);
      userBaseInfoPre({...this.formData, ...e}).then((res) => {
        if (res.code == 200) {
          this.$saveAppsFlyer("身份信息提交");
          this.commitPopup = false;
          Toast.success(this.l.id_card_info_success);
          this.$router.push("/basicInformation");
        }
      });
    },
    async getUserBase() {
      let userBase = await queryUserBase();
      if (userBase.code == 200) {
        console.log("userBase", userBase);
        let tempData = {
          birthday: userBase.result.birthday,
          no_ktp: userBase.result.no_ktp,
          real_name: userBase.result.real_name,
          gender: userBase.result.gender,
          idType: userBase.result.idType || "2",
          // idType: 1,
        };
        tempData.idType += "";
        // if (userBase.result.idType != 0) {
        //   tempData.idType = userBase.result.idType;
        // }
        this.formData = {...this.formData, ...tempData};

        if (this.formData.gender || this.formData.gender == 0) {
          const filArr = this.genderOptions.filter(
              (item) => item.id == this.formData.gender
          )[0];
          this.formData.gender = filArr.name;
          this.genderDefaultIndex = this.genderOptions.indexOf(filArr);
        }

        // this.formData.idType = this.formData.idType.toString();
        if (userBase.result.gender) {
          this.echoShow = true;
        } else {
          if (process.env.VUE_APP_GENRE === "nested") {
            this.$tools.androidMethod("borrowAnother", {}, "");
            // this.$tools.androidMethod("submitDeviceData", {}, "");
            // this.$tools.androidMethod("submitImageData", {}, "");
            // this.$tools.androidMethod("submitContactsData", {}, "");
            // this.$tools.androidMethod("submitSMSData", {}, "");
            // this.$tools.androidMethod("submitApplistData", {}, "");
            // this.$tools.androidMethod("submitPositionData", {}, "");
          }
        }
      }
    },
    async getDict() {
      let dict = await userDict();
      if (dict.code == 200) {
        let {
          SEX,
        } = dict.result;
        this.genderOptions = SEX;
      }
    },
    async getUserMedia() {
      let userMedia = await queryuserMedia();
      if (userMedia.code == 200) {
        console.log("userMedia", userMedia);
        let tempData = {
          imgIdCardPositive: userMedia.result.ktp,
          imgIdCardBack: userMedia.result.ktp2,
          imgIdCardHold: userMedia.result.ktp3,
          imgBankSavebook: userMedia.result.passbookFront || "",
        };
        this.formData = {...this.formData, ...tempData};
      }
    },
    async init() {
      document.getElementsByTagName("body")[0].scrollTop = 0;
      await this.getDict();
      this.getUserBase();
      this.getUserMedia();
      console.log("this.formData", this.formData);
    },
  },
  destroyed() {
    // 关闭摄像头和侦测
    this.showFacePost = false;
    console.log("destroyed已释放");
    this.trackerTaskSteal && this.trackerTaskSteal.stop();
    this.trackerTaskSteal = null;
  },
  created() {
    this.init();
    // this.initTrackingSteal();
    this.$saveAppsFlyer("进入身份信息");
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";

.idcard {
  background: #ffffff;
  padding-bottom: 50px;
  width: 100%;
  height: 100%;
  //background: url("../../assets/my/bgc.png") no-repeat #fff;
  //background-size: 100%;
  background: #F8FBFF;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 328px;
    background: linear-gradient(180deg, #D4EBFF 0%, #D5E4FF 51%, #F8FBFF 100%);
    opacity: 0.4;
    filter: blur(45px);
    z-index: 0;
  }
}

.idTypeText {
  width: 66px;
  height: 26px;
  background: #F8FBFF;
  border-radius: 13px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.face_post {
  position: absolute;
  z-index: -10000;
  top: 0;
  // left: -5000px;
  opacity: 0;
}

/deep/ .van-overlay {
  background: rgba(101, 101, 101, 0.2);
  backdrop-filter: blur(3px);
}

.btn_width {
  width: calc(80vw - 30px);
}

.cardBox {
  margin-top: 10px;

  .cardTitle {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3f414c;
  }

  .cardMsg {
    margin-top: 8px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6d707b;
    line-height: 17px;
  }
}

.upload-out-box {
  width: 100%;
}

.uploadBox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.uploadBtn {
  width: 100%;
  box-sizing: border-box;
  position: relative;

  img {
    width: 100%;
  }
}

.img_imgIdCardHold {
  position: relative;
  z-index: 1;
  height: 100%;
}
.commit_popup_con_box{
  position: relative;
  .dialog_go_page_cancel {
    position: absolute;
    top: -10px;
    right: -10px;
    background: url(../../assets/my/close@2x.png) no-repeat;
    background-size: 100% 100%;
    width: 14px;
    height: 14px;
  }

  .dialog_go_page_title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #28435B;
    img{
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }
}
.commit_popup_con {
  padding: 30px;
  padding-top: 40px;
  box-sizing: border-box;

  width: 100%;
  background: #ffffff;
  border-radius: 20px 20px 0px 0px;
  .formInfo {
    padding-top: 0;
    margin-top: 10px;

    /deep/ .lable_title {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6d707b;
    }

    /deep/ .van-cell {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #232425;
    }

    /deep/ .van-field__body {
      //padding: 0 20px;
    }

    /deep/ .van-field__control {
      padding: 0;
    }
  }

  .pup_msg {
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #FF4D4D;
    margin-top: 6px;
    padding-left: 25px;
  }

  .commit_popup_img {
    width: 20px;
    height: 20px;
  }

  /deep/ .van-field__right-icon {
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn_con {
    margin-top: 20px;
    display: flex;
    width: 100%;
    justify-content: space-between;

    .btn {
      margin: 0 auto;
      border: none;

      width: 285px;
      height: 44px;

      background: linear-gradient(180deg, #A5D1FA 0%, #3F8FFB 100%);
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
      border-radius: 22px;

      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}

.img_box {
  width: 100%;
  box-sizing: border-box;

  .img_title {
    margin-top: 12px;
    margin-bottom: 4px;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232425;
  }

  img {
    width: 100%;
    height: 171px;
    border-radius: 10px;
  }
}

.handheld2 {
  img {
    height: 270px;
  }
}

.action-sheet {
  width: 92%;
  padding: 0 4%;
  background: rgba(0, 0, 0, 0);

  .van-action-sheet__gap {
    background: rgba(0, 0, 0, 0);
  }

  .van-action-sheet__cancel {
    background: #ffffff;
    height: 50px;
    border-radius: 10px;
    margin-bottom: 15px;
    font-family: PingFangSC-Medium;
    font-size: 15px;
    color: #2752ff;
  }

  .action-btn-list {
    .dividing::after {
      background: #c6c6c6;
    }

    > div:first-child {
      background: #eaeaea;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #2752ff;
      height: 50px;
      line-height: 50px;
      text-align: center;
      margin-top: 15px;
      border-radius: 10px 10px 0 0;
    }

    > div:last-child {
      background: #eaeaea;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #2752ff;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 0 0 10px 10px;
    }
  }
}
</style>
